// extracted by mini-css-extract-plugin
export default {"container":"Table_container__k42fv","posts_box":"Table_posts_box__WLAQS","progressContainer":"Table_progressContainer__MGQ46","redRow":"Table_redRow__XBQXL"};